import React, { Component } from 'react';

const initData = {
    pre_heading: "erdNFT",
    heading: "Discover, create, collect, and sell extraordinary NFTs",
    content: "Explore on the community driven NFT marketplace",
    btn_1: "Explore",
    btn_2: "Create"
}

class Hero extends Component {
    state = {
        data: {}
    }
    componentDidMount(){
        this.setState({
            data: initData
        })
    }
    render() {
        return (
            <section className="hero-section">
                <div className="container">
            
                    <div className="row">
                        <div className="col-12">
                            {/* Intro */}
                            <div className="intro d-flex justify-content-between align-items-end m-0">
                                <div className="intro-content">
                                    <span> What we are cooking </span>
                                    <h3 className="mt-3 mb-0">Roadmap</h3>
                                </div>
                                <div className="intro-btn d-none">
                                    <a className="btn content-btn" href="/explore">See details</a>
                                </div>
                            </div>
                        </div>
                    </div>
            
                    <div className="row mt-3">
                        <div className="col-12 col-md-4 text-center">
                            <h2 className="mt-4">Q4 2021</h2>
                        </div>
                        <div className="col-12 col-md-8">
                            <h4>erdNFT pre launch</h4>
                            <p>
                                Website redesign <br></br>
                                Giveaway functionality
                            </p>
                            {/* Buttons */}
                            <div className="button-group d-none">
                                <a className="btn btn-bordered-white" href="/explore"><i className="icon-rocket mr-2" />{this.state.data.btn_1}</a>
                                <a className="btn btn-bordered-white" href="/create"><i className="icon-note mr-2" />{this.state.data.btn_2}</a>
                            </div>
                        </div>
                    </div>
            
                    <div className="row mt-5">
                        <div className="col-12 col-md-4 text-center">
                            <h2 className="mt-4">Q1 2022</h2>
                        </div>
                        <div className="col-12 col-md-8">
                            <h4>erdNFT launch</h4>
                            <p>
                                launch the legit collections DAO <br/>
                                open applications <br/>
                                launch marketplace <br/>
                            </p>
                            {/* Buttons */}
                            <div className="button-group d-none">
                                <a className="btn btn-bordered-white" href="/explore"><i className="icon-rocket mr-2" />{this.state.data.btn_1}</a>
                                <a className="btn btn-bordered-white" href="/create"><i className="icon-note mr-2" />{this.state.data.btn_2}</a>
                            </div>
                        </div>
                    </div>
            
                    <div className="row mt-5">
                        <div className="col-12 col-md-4 text-center">
                            <h2 className="mt-4">Q2 2022</h2>
                        </div>
                        <div className="col-12 col-md-8">
                            <h4> Launchpad </h4>
                            <p>
                                collection launchpad <br/> 
                                bulk NFT minting <br/>
                                SC management platform
                            </p>
                            {/* Buttons */}
                            <div className="button-group d-none">
                                <a className="btn btn-bordered-white" href="/explore"><i className="icon-rocket mr-2" />{this.state.data.btn_1}</a>
                                <a className="btn btn-bordered-white" href="/create"><i className="icon-note mr-2" />{this.state.data.btn_2}</a>
                            </div>
                        </div>
                    </div>
            
                    <div className="row mt-5">
                        <div className="col-12 col-md-4 text-center">
                            <h2 className="mt-4">Q3 2022</h2>
                        </div>
                        <div className="col-12 col-md-8">
                            <h4> Integrations and Extensions </h4>
                            <p>
                                to be announced
                            </p>
                            {/* Buttons */}
                            <div className="button-group d-none">
                                <a className="btn btn-bordered-white" href="/explore"><i className="icon-rocket mr-2" />{this.state.data.btn_1}</a>
                                <a className="btn btn-bordered-white" href="/create"><i className="icon-note mr-2" />{this.state.data.btn_2}</a>
                            </div>
                        </div>
                    </div>
            
                </div>
            </section>
        );
    }
}

export default Hero;